import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { AnnouncementIcon, Logo, PlusIcon, SearchIcon } from 'assets'
import { useOutsideClick } from 'Hooks'
import { useDispatch, useSelector } from 'react-redux'
import { createImageUrl } from 'utils/createImageUrl'
import {
   getAllChannelListAction,
   getChannelDetailsAction,
   resetChannelData,
   setSelectChannelId
} from 'store/action/settingsReducer'
import AddChannelModal from './components/AddChannelModal'
import OpenSearchModal from './components/OpenSearchModal'
import { resetAddChannelData, setDashboardStatus } from 'store/action/AuthRedux'
import FeedBackModal from './components/FeedBackModal'
import { menuItems } from './menuItem'
import { onResetVideoCount, setPageNumberAction } from 'store/action/videoReducer'

function Sidebar(props) {
   const { isMini, onMiniSidebar, isShowMobileMenu, onMobileMenu } = props
   const settingData = useSelector((state) => state.settings)
   const { channelList, selectedUserTypes, selectedChannelID } = settingData
   const authData = useSelector((state) => state.user)
   const { userData, addChannel, addChannelData, addChannel504StatusError } = authData
   const [searchUser, setSearchUser] = useState(false)
   const location = useLocation()
   const [openAddChannelModal, setOpenAddChannelModal] = useState(false)
   const [secondaryChannelList, setSecondaryChannelList] = useState([])
   const [remaining, setRemaining] = useState([])
   const [showMoreUser, setShowMoreUser] = useState(false)
   const [remainingImageArray, setRemainingImageArray] = useState([])
   const [searchParams, setSearchParams] = useSearchParams()

   const dispatch = useDispatch()
   const navigate = useNavigate()
   const getParams = new URLSearchParams(location.search)
   const [selected, setSelected] = useState(null)
   const [arr, setArr] = useState(channelList || [])
   const [openSearchModal, setOpenSearchModal] = useState(false)
   const [openFeedBackModal, setOpenFeedBackModal] = useState(false)
   const [activeItem, setActiveItem] = useState(null)
   const ref = useOutsideClick(() => {
      isShowMobileMenu && onMobileMenu()
   })

   useEffect(() => {
      // Find the index of the current route in the menu items
      const index = menuItems.findIndex(
         (item) => item.path === `/${location.pathname.split('/')[1]}`
      )
      setActiveItem(index)
   }, [location.pathname])

   const onCloseAddChannelModal = () => {
      setOpenAddChannelModal(false)
      dispatch(setDashboardStatus(false))
   }

   useEffect(() => {
      if (channelList && channelList.length > 0) {
         setArr(channelList)
         setSelected(null)
      } else {
         setArr([])
         dispatch(resetChannelData())
         setSelected(null)
      }
      return () => {}
   }, [channelList])

   useEffect(() => {
      if (arr && arr?.length > 0) {
         let upArr
         if (selected?.channel_id) {
            upArr = [...arr, selected]
            const selectedItem = upArr.find((obj) => obj.channel_id === selected?.channel_id)
            upArr = upArr.filter((obj) => obj.channel_id !== selected?.channel_id)
            setSelected(selectedItem)
         } else {
            upArr = arr
         }

         const bookmarks = upArr.filter((obj) => obj.is_bookmark)
         const nonBookmarks = upArr.filter((obj) => !obj.is_bookmark)
         const firstFourItems =
            bookmarks.length >= 4
               ? bookmarks.slice(0, 4)
               : [...bookmarks, ...nonBookmarks.slice(0, 4 - bookmarks.length)]

         const remainingItems = arr.filter((obj) => !firstFourItems.includes(obj))
         const logosInRemaining = remainingItems
            .slice(0, 4)
            .map((item) => createImageUrl(item.logo))

         setSecondaryChannelList(firstFourItems)
         setRemaining(remainingItems)
         setRemainingImageArray(logosInRemaining)
      } else {
         setSecondaryChannelList([])
         setRemaining([])
         setRemainingImageArray([])
      }
   }, [arr])

   const onChangeChannel = (channel_id, is_new = false, add_channel_obj = null) => {
      dispatch(setPageNumberAction(1))
      dispatch(onResetVideoCount())
      isShowMobileMenu && onMobileMenu()
      let updatedArr
      if (is_new) {
         if (arr[0]?.is_from === add_channel_obj?.is_from) {
            updatedArr = [...arr, add_channel_obj]
            dispatch(resetAddChannelData())
         } else {
            dispatch(getAllChannelListAction({ user_type: add_channel_obj?.is_from }))
            return
         }
      } else {
         updatedArr = [...arr]
      }
      if (selected) {
         updatedArr = [...updatedArr, selected]
      }
      const selectedItem = updatedArr.find((obj) => obj.channel_id === channel_id)
      updatedArr = updatedArr.filter((obj) => obj.channel_id !== channel_id)
      setSelected(selectedItem)
      // dispatch(getChannelDetailsAction({ channel_id: channel_id }))
      setSearchParams({
         userType: selectedUserTypes,
         channel_id: channel_id
      })
      dispatch(setSelectChannelId(channel_id))
      // if (is_new) {
      navigate(`/dashboard/?userType=${selectedUserTypes}&channel_id=${channel_id}`, {
         replace: true
      })
      // }
      setArr(updatedArr)
   }

   useEffect(() => {
      if (addChannelData && addChannelData?.channel_id) {
         onChangeChannel(addChannelData?.channel_id, true, addChannelData)
      }
   }, [channelList, addChannelData])

   useEffect(() => {
      if (getParams.get('channel_id') === '' || getParams.get('channel_id') === null) {
         if (secondaryChannelList && secondaryChannelList?.length > 0) {
            // dispatch(getChannelDetailsAction({ channel_id: secondaryChannelList[0]?.channel_id }))
            setSearchParams({
               userType: selectedUserTypes,
               channel_id: secondaryChannelList[0]?.channel_id
            })
            dispatch(setSelectChannelId(secondaryChannelList[0]?.channel_id))
         }
      }
      return () => {}
   }, [secondaryChannelList])

   const IsActiveMenu = (id) => {
      return id === selectedChannelID ? 'active' : ''
   }

   return (
      <div>
         <aside
            ref={ref}
            className={`atenya-side-bar ${isMini ? 'mini-side-bar' : 'big-side-bar'} ${
               isShowMobileMenu && 'show-mobile-sidebar'
            } `}>
            <div className="logo-wrap">
               <div
                  className="logo-section"
                  onClick={() => {
                     navigate(
                        `/dashboard/?userType=${selectedUserTypes}&channel_id=${selectedChannelID}`
                     )
                     onMobileMenu()
                  }}>
                  <img src={Logo} alt="logo" />
               </div>
               {/* <div className="logo-details">
                  <img src={AtenyaImage} alt="AtenyaImage" />
               </div> */}
            </div>
            <div className="manu-list-section mb-3 sidebar-mobile-menu">
               {menuItems &&
                  menuItems.length > 0 &&
                  menuItems.map((item, i) => {
                     return (
                        <div
                           className={`manu-name-section ${activeItem === i ? 'active' : ''}`}
                           key={i}
                           onClick={onMobileMenu}>
                           <Link to={`${item.path}${location?.search}`}>{item?.name}</Link>
                        </div>
                     )
                  })}
            </div>

            {/* <div className="add-boder-bottom"></div> */}
            <div className="list-channel-influencers">
               <div className="channel-list-section">
                  <div className={`owner-logo-section mobile-owner-logo-section `}>
                     <img
                        src={userData?.profile ? createImageUrl(`${userData?.profile}`) : Logo}
                        alt="owner_logo"
                        loading="lazy"
                     />
                  </div>
                  <div className="position-relative selected-section-mobile mo-d-flex">
                     <div
                        className="owner-logo-section add-more-icon add-border"
                        title="Add Channel"
                        onClick={() => {
                           setOpenAddChannelModal(true)
                           onMobileMenu()
                        }}>
                        <PlusIcon />
                     </div>
                     <div
                        className="owner-logo-section add-border   de-search-icon-d-none"
                        onClick={() => {
                           setOpenSearchModal(true)
                           onMobileMenu()
                        }}>
                        <SearchIcon />
                     </div>
                  </div>
               </div>
               {/* <div className="add-boder-bottom"></div> */}
               <div className="channel-list-section">
                  <div
                     className="owner-logo-section add-border selected-section-mobile search-icon-d-none"
                     onClick={() => {
                        setOpenSearchModal(true)
                     }}>
                     <SearchIcon />
                  </div>
                  {selected && (
                     <div className="channel-image-with-name selected-section-mobile">
                        <div
                           className={`owner-logo-section ${IsActiveMenu(selected?.channel_id)}`}
                           onClick={() => {
                              onChangeChannel(selected?.channel_id)
                           }}>
                           <img
                              src={createImageUrl(selected?.logo)}
                              alt="owner_logo"
                              title={selected?.channel_name}
                           />
                        </div>
                        <div
                           className="only-mobile-show ms-2"
                           onClick={() => {
                              onChangeChannel(selected?.channel_id)
                           }}>
                           <p>{selected?.channel_name}</p>
                        </div>
                     </div>
                  )}
                  {secondaryChannelList &&
                     secondaryChannelList?.length > 0 &&
                     secondaryChannelList?.map((item, i) => {
                        // if (selected?.channel_id !== item?.channel_id) {
                        return (
                           <div className="channel-image-with-name selected-section-mobile">
                              <div
                                 className={`owner-logo-section ${IsActiveMenu(item?.channel_id)}`}
                                 key={i}
                                 onClick={() => {
                                    onChangeChannel(item?.channel_id)
                                 }}>
                                 <img
                                    src={createImageUrl(item?.logo)}
                                    alt="owner_logo"
                                    title={item?.channel_name}
                                 />
                              </div>
                              <div
                                 className="only-mobile-show ms-2"
                                 onClick={() => {
                                    onChangeChannel(item?.channel_id)
                                 }}>
                                 <p>{item?.channel_name}</p>
                              </div>
                           </div>
                        )
                        // }
                     })}
                  {showMoreUser &&
                     remaining &&
                     remaining?.length > 0 &&
                     remaining.map((item, i) => {
                        // if (selected?.channel_id !== item?.channel_id) {
                        return (
                           <div className="channel-image-with-name selected-section-mobile">
                              <div
                                 className={`owner-logo-section ${IsActiveMenu(item?.channel_id)}`}
                                 key={i}
                                 onClick={() => {
                                    onChangeChannel(item?.channel_id)
                                 }}>
                                 <img
                                    src={createImageUrl(item?.logo)}
                                    alt="owner_logo"
                                    title={item?.channel_name}
                                 />
                              </div>
                              <div
                                 className="only-mobile-show ms-2 "
                                 onClick={() => {
                                    onChangeChannel(item?.channel_id)
                                 }}>
                                 <p>{item?.channel_name}</p>
                              </div>
                           </div>
                        )
                        // }
                     })}

                  {remainingImageArray && remainingImageArray?.length > 0 && (
                     <div
                        className="owner-logo-section add-border show-more-user"
                        onClick={() => {
                           setShowMoreUser(!showMoreUser)
                        }}>
                        {remainingImageArray.map((item, i) => {
                           return <img src={item} alt="owner_logo" key={i} />
                        })}
                     </div>
                  )}
               </div>
            </div>
            {/* <div className="add-boder-bottom"></div> */}
            <div
               className="owner-logo-section add-border bottom-announcement"
               onClick={() => setOpenFeedBackModal(true)}>
               <AnnouncementIcon />
            </div>
         </aside>

         {openAddChannelModal && (
            <AddChannelModal show={openAddChannelModal} onClose={onCloseAddChannelModal} />
         )}
         {openSearchModal && (
            <OpenSearchModal
               show={openSearchModal}
               onChangeChannel={onChangeChannel}
               onClose={() => {
                  setOpenSearchModal(false)
               }}
            />
         )}

         {openFeedBackModal && (
            <FeedBackModal show={openFeedBackModal} onClose={() => setOpenFeedBackModal(false)} />
         )}
      </div>
   )
}

export default Sidebar
